import { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, MessageCircle } from "lucide-react";
import { MSG } from "../lib/site";
import { useLead } from "../lib/LeadContext";

export const NAV_ITEMS = [
  { to: "/", label: "Início", testid: "nav-link-inicio" },
  { to: "/informacoes", label: "Informações", testid: "nav-link-informacoes" },
  { to: "/renovacao", label: "Renovação", testid: "nav-link-renovacao" },
  { to: "/download", label: "Download", testid: "nav-link-download" },
];

const Header = () => {
  const [open, setOpen] = useState(false);
  const { openLead } = useLead();

  return (
    <header className="fixed inset-x-0 top-0 z-50 glass border-b border-white/[0.06]" data-testid="site-header">
      <div className="mx-auto flex h-[72px] max-w-7xl items-center justify-between px-5 sm:px-8">
        <Link to="/" data-testid="header-logo-link" className="flex items-center gap-3">
          <img
            src="/assets/wordmark.webp"
            alt="NOVA ÉRA TV"
            className="h-9 w-auto sm:h-10"
          />
        </Link>

        <nav className="hidden items-center gap-8 lg:flex" data-testid="desktop-nav">
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              data-testid={item.testid}
              className={({ isActive }) =>
                `text-[13px] font-semibold uppercase tracking-[0.16em] transition-colors duration-300 ${
                  isActive ? "text-lime-350" : "text-slate-400 hover:text-slate-100"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            onClick={() => openLead(MSG.hero)}
            data-testid="header-whatsapp-cta"
            className="hidden items-center gap-2 rounded-full bg-lime-350 px-5 py-2.5 text-[12px] font-bold uppercase tracking-wider text-ink-950 transition-[transform,box-shadow] duration-300 hover:-translate-y-0.5 glow-lime sm:inline-flex"
          >
            <MessageCircle className="h-4 w-4" />
            Contratar
          </button>
          <button
            onClick={() => setOpen(!open)}
            data-testid="mobile-menu-toggle"
            aria-label="Abrir menu"
            className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-white/10 text-slate-200 lg:hidden"
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
            className="overflow-hidden border-t border-white/[0.06] glass lg:hidden"
            data-testid="mobile-nav"
          >
            <div className="flex flex-col gap-1 px-6 py-5">
              {NAV_ITEMS.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  end={item.to === "/"}
                  onClick={() => setOpen(false)}
                  data-testid={`mobile-${item.testid}`}
                  className={({ isActive }) =>
                    `rounded-lg px-4 py-3 font-display text-2xl uppercase tracking-wider transition-colors ${
                      isActive ? "bg-lime-350/10 text-lime-350" : "text-slate-300 hover:bg-white/5"
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              ))}
              <button
                onClick={() => {
                  setOpen(false);
                  openLead(MSG.hero);
                }}
                data-testid="mobile-whatsapp-cta"
                className="mt-3 inline-flex items-center justify-center gap-2 rounded-full bg-lime-350 px-6 py-3.5 text-sm font-bold uppercase tracking-wider text-ink-950"
              >
                <MessageCircle className="h-4 w-4" />
                Contratar agora
              </button>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};

export default Header;
